module.exports = __webpack_public_path__ + "img/099_L.f4b8d4f8.png";